import { useEffect, useState } from 'react';

import { getDeviceInfo } from 'technical/media/services/get-device-info';

export function useMediaType() {
  const [deviceInfo, setDeviceInfo] = useState(getDeviceInfo);

  const updateDeviceInfo = () => {
    const updatedDeviceInfo = getDeviceInfo();

    setDeviceInfo(updatedDeviceInfo);
  };

  useEffect(
    () => {
      updateDeviceInfo();

      window.addEventListener('resize', updateDeviceInfo);
      window.addEventListener('orientationchange', updateDeviceInfo);

      return () => {
        window.removeEventListener('resize', updateDeviceInfo);
        window.removeEventListener('orientationchange', updateDeviceInfo);
      };
    },
    // Only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return deviceInfo;
}
